import { ref } from 'vue';

const DEFAULT_DURATION_MS = 2200;
const THROTTLE_MS = 2500;

/** @type {import('vue').Ref<{ id: number, text: string } | null>} */
export const activeCreditClaimToast = ref(null);

let toastSeq = 0;
let hideTimer = null;
/** @type {Map<string, number>} */
const lastShownAt = new Map();

/**
 * 居中文字弹窗（体验金 / 奖励金到账提醒）。
 * @param {string} text
 * @param {{ dedupeKey?: string, durationMs?: number }} [options]
 */
export function showCreditClaimToast(text, options = {}) {
  const msg = String(text ?? '').trim();
  if (!msg) return;

  const dedupeKey = String(options.dedupeKey || msg);
  const now = Date.now();
  const last = lastShownAt.get(dedupeKey) ?? 0;
  if (now - last < THROTTLE_MS) return;
  lastShownAt.set(dedupeKey, now);

  if (hideTimer != null) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  toastSeq += 1;
  activeCreditClaimToast.value = { id: toastSeq, text: msg };

  const durationMs = Number(options.durationMs);
  hideTimer = setTimeout(
    () => {
      activeCreditClaimToast.value = null;
      hideTimer = null;
    },
    Number.isFinite(durationMs) && durationMs > 0 ? durationMs : DEFAULT_DURATION_MS
  );
}

export function clearCreditClaimToast() {
  if (hideTimer != null) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
  activeCreditClaimToast.value = null;
}
